<template>
  <header
    :class="[
      'header-area bg-white text-center text-md-start pt-15 pb-15 ps-15 pe-15 ps-md-20 pe-md-20 pe-lg-30 transition mb-25 position-fixed radius-7',
      { sticky: isSticky },
    ]"
    id="header"
  >
    <div class="custom-pre-header">
      <div class="d-flex justify-content-center justify-content-md-start">
        <div class="header-left-side justify-content-center justify-content-md-start d-flex align-items-center">
          <button
            class="header-burger-menu transition position-relative lh-1 bg-transparent p-0 border-0"
            id="header-burger-menu"
            @click="stateStoreInstance.onChange"
          >
            <i class="flaticon-menu-3"></i>
          </button>
        </div>

        <div class="header-left-side justify-content-center justify-content-md-start d-flex align-items-center">
          <select 
            v-if="getOperations.length && enabledOperationFilter" 
            v-model="selectedOperation" 
            @change="onOperationChange" 
            class="form-select shadow-none text-black fs-md-15"
          >
            <option disabled value="">Selecione a operação</option>
            <option v-for="operation in getOperations"
                    :key="operation.id"
                    :value="operation.id">
              {{ operation.name }}
            </option>
          </select>
        </div>
      </div>

      <div class="custom-options-right d-flex">
        <div class="header-right-side d-flex align-items-center justify-content-center">
          <LightDarkSwtichBtn />
        </div>

        <div class="profile-dropdown d-flex justify-content-end">
  
            <button
              class="text-end fs-14 text-black-emphasis d-flex align-items-center p-0 position-relative bg-transparent border-0 transition lh-1"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <span class="title d-lg-block">
                <span class="d-block fw-bold">{{ getConfigurations.name }}</span>
                <span class="text-body-emphasis fw-semibold fs-13">Admin</span>
              </span>
            </button>

            <div class="dropdown dropdown-menu rounded-0 bg-white border-0 end-0 ps-10 radius-7">
              <ul class="ps-0 mb-0 list-unstyled dropdown-body">
                <li
                  v-if="getConfigurations.role === 'admin'"
                  class="text-body-secondary fw-semibold transition position-relative"
                >
                  <i class="flaticon-setting"></i>
                  Configurações
                  <router-link
                    to="/operations"
                    class="d-block position-absolute start-0 top-0 end-0 bottom-0 text-decoration-none"
                  ></router-link>
                </li>
                <li
                  class="pointer text-body-secondary fw-semibold transition position-relative"
                  data-bs-toggle="modal" data-bs-target="#verticallyCenteredModal"
                >
                  <i class="flaticon-logout"></i>
                  Deslogar
                </li>
              </ul>
            </div>

          </div>
      </div>
    </div>
  </header>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, onBeforeUnmount } from "vue";
import LightDarkSwtichBtn from "./LightDarkSwtichBtn.vue";
import stateStore from "../../utils/store";
import { useStore } from "vuex";
import { mapGetters } from 'vuex';
import { useRoute } from "vue-router";
import { computed as vComputed } from 'vue';

const STORAGE_KEY = 'selected_operation_id';

export default defineComponent({
  name: "MainHeader",
  components: {
    LightDarkSwtichBtn,
  },
  methods: {
  },
  setup() {
    const store = useStore(); 
    const stateStoreInstance = stateStore;
    const isSticky = ref(false);
    const selectedOperation = ref<string>("");
    const route = useRoute();

    const enabledOperationFilter = vComputed(() => {
    const p = route?.path || '';
    return !['/operation', '/operations', '/payment', '/documentation', '/users']
      .some(prefix => p.startsWith(prefix));
    });

    const onScroll = () => (isSticky.value = window.scrollY >= 100);

    const onOperationChange = () => {
      const ops = store.getters.getOperations || [];

      const isValid = selectedOperation.value &&
                      ops.some((op) => String(op.id) === String(selectedOperation.value));

      if (isValid) {
        localStorage.setItem(STORAGE_KEY, selectedOperation.value);
        window.location.reload();
      } else {
        localStorage.removeItem(STORAGE_KEY);
        selectedOperation.value = "";
        alert("Operação inválida, selecione novamente.");
      }
    };

    onMounted(async () => {
      window.addEventListener("scroll", onScroll);
    });

    onBeforeUnmount(() => {
      window.removeEventListener("scroll", onScroll);
    });

    return {
      isSticky,
      stateStoreInstance,
      selectedOperation,
      onOperationChange,
      enabledOperationFilter
    };
  },
  computed:{
    ...mapGetters([
      'getConfigurations',
      'getOperations'
    ])
  },
});
</script>

<style scoped>
.custom-pre-header{
    display: flex;
    justify-content: space-between;
    flex-wrap: nowrap;
}

.custom-option-right{
  display: flex !important;
  flex-wrap: nowrap;
}

.form-select {
  padding-right: 3rem; /* garante espaço antes da setinha */
  text-overflow: ellipsis; /* se o texto for muito grande, coloca "..." */
  white-space: nowrap; /* evita quebra de linha */
  overflow: hidden; /* esconde o excesso de texto */
}
</style>
